import App from 'app/app.js';

function $qHelperService($q) {
  this.allSettled = function (promiseArray) {
    return $q.all(
      promiseArray.map(function (value) {
        return $q
          .resolve(value)
          .then(function (result) {
            return { state: 'fulfilled', value: result };
          })
          .catch(function (error) {
            return { state: 'rejected', reason: error };
          });
      })
    );
  };
}

App.service('$qHelperService', ['$q', $qHelperService]);
